import React, { memo } from 'react'
import { Typography } from '@mui/material'
import { ErrorTypographyProps } from './ErrorTypography.types'

function ErrorTypography({ text }: ErrorTypographyProps) {
    return (
        <Typography variant="body1" component="h5" color="error" align="center">
            {text}
        </Typography>
    )
}

export default memo(ErrorTypography)
